/* eslint-disable @typescript-eslint/no-explicit-any */
import { yupResolver } from "@hookform/resolvers/yup";
import { UploadImage } from "components";
import { MediaDirectoryKeys } from "constants/enums";
import { Controller, Resolver, useForm } from "react-hook-form";

import { staffManagerSchema } from "../../../helpers";
import {
  NameFields,
  PasswordFields,
  EmailField,
  PrivilegesSelector
} from "./atoms";
import {
  StaffManagerFormProps,
  StaffManagerFormValues
} from "./StaffManagerForm.types";

import styles from "./StaffManagerForm.module.scss";

export const StaffManagerForm = ({
  formId,
  defaultValues,
  onSubmit
}: StaffManagerFormProps) => {
  const { control, handleSubmit } = useForm<StaffManagerFormValues>({
    defaultValues,
    resolver: yupResolver(staffManagerSchema) as Resolver<any, any>
  });

  return (
    <form id={formId} className={styles.form} onSubmit={handleSubmit(onSubmit)}>
      <Controller
        control={control}
        name="image"
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <UploadImage
            className={styles.form_imageBlock}
            variant="primary"
            uploadLabel="Add photo"
            editLabel="Change photo"
            deleteLabel="Delete photo"
            value={value}
            onChange={onChange}
            errorMessage={error?.message}
            uploadDirectoryKey={MediaDirectoryKeys.InventoryManager}
            data-testid="staff-manager--image"
          />
        )}
      />

      <NameFields control={control} />

      <EmailField control={control} />

      <PasswordFields control={control} />

      <PrivilegesSelector control={control} />
    </form>
  );
};
